import React, { createContext, useReducer, useContext, useCallback, Dispatch } from 'react';
import { queryActivetyListById } from '@/service/vip';
import { message } from '@/components/UI';

interface LuckyState {
    // 活动
    LUCKY_ACTIVE?: any;
}

type LuckyAction = {
    type: string;
    payload: any;
};

const initState: LuckyState = {
    // 抽奖活动
    LUCKY_ACTIVE: undefined,
};

const fsReducer = (state: LuckyState, action: LuckyAction): LuckyState => {
    const { type, payload } = action;
    switch (type) {
        case 'GET_ACTIVE_LIST_TYPES':
            return { ...state, LUCKY_ACTIVE: payload };
        default:
            return state;
    }
};

export const LuckyContext = createContext<{ state: LuckyState; dispatch: React.Dispatch<LuckyAction> }>({
    state: initState,
    dispatch: () => null,
});

const asyncDispatch = (dispatch: Dispatch<LuckyAction>) =>
    useCallback(async ({ type, payload }: LuckyAction) => {
        switch (type) {
            case 'getActives': // 查询活动列表
                const { id, locale, isEditStatus } = payload;
                if (!id) return;
                queryActivetyListById(isEditStatus, locale, id).then((res) => {
                    if (res?.code === '0') {
                        // 过滤出可用的活动
                        const active = res?.data?.[0];
                        dispatch({
                            type: 'GET_ACTIVE_LIST_TYPES',
                            payload: active || [],
                        });
                    }
                });
                return;
            default:
                dispatch({ type, payload });
        }
    }, []);

export function LuckyProvider({ children }: { children: React.ReactNode }) {
    const [state, dispatch] = useReducer(fsReducer, initState);
    return <LuckyContext.Provider value={{ state, dispatch: asyncDispatch(dispatch) }}>{children}</LuckyContext.Provider>;
}

export const useLuckyStore = () => {
    const store = useContext(LuckyContext);
    return store.state;
};

export const useLuckyDispatch = () => {
    const store = useContext(LuckyContext);
    return store.dispatch;
};
